import PanelPage from 'navigation/pages/PanelPage';
import ProductCard from 'sections/product/partials/ProductCard';
import RowProductCard from 'sections/product/partials/RowProductCard';
import Form from 'components/form/Form';
import modulesMap from 'core/modulesMap';
import { bindMethod } from 'helpers/bind';
import CartReinsurance from './CartReinsurance';
class Cart extends PanelPage {
    static pageName = 'cart';
    getModulesMap() {
        return {
            ...modulesMap,
            products: ['.row-product-card', RowProductCard],
            productsRelated: ['.product-card', ProductCard],
            couponForm: ['.checkout-promo__form', Form],
            cartReinsurance: ['.cart__reinsurance', CartReinsurance]
        };
    }
    initialized() {
        super.initialized();
        this.updateSizes();
        if (this.refs.cartActions)
            new ResizeObserver(this.resize.bind(this)).observe(this.refs.cartActions);
    }
    updateSizes = () => {
        const cartHeaderHeight = this.refs.cartHeader.getBoundingClientRect().height;
        this.el.style.setProperty('--cart-header-height', `${cartHeaderHeight}px`);
        if (this.refs.cartActions) {
            const cartActionsHeight = this.refs.cartActions.getBoundingClientRect().height;
            this.el.style.setProperty('--cart-actions-height', `${cartActionsHeight}px`);
        }
        if (this.refs.cartReinsurance) {
            const cartReinsuranceHeight = this.refs.cartReinsurance.getBoundingClientRect().height;
            this.el.style.setProperty('--cart-reinsurance-height', `${cartReinsuranceHeight}px`);
        }
    };
    bindEvents(add) {
        super.bindEvents(add);
        const method = bindMethod(add);
        if (this.refs.clearCoupon)
            this.refs.clearCoupon[method]('click', this.clearCoupon);
    }
    onUpdate() {
    }
    clearCoupon = () => {
        this.modules.couponForm.clear();
        this.modules.couponForm.submit().then(() => {
            this.modules.couponForm.setSubmitted(false);
        });
    };
    resize() {
        this.updateSizes();
        super.resize();
    }
    flush() {
        super.flush();
    }
}
export default Cart;
